module.exports = __webpack_public_path__ + "static/media/sgImgSmall.ed856269.png";